import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Holds the CB2 journey common-value map (`paramValues`) for the active marketplace
 * runtime. Used by block visibility expressions (`getJourneyParam`) and
 * `BlockConfigContextService`.
 */
@Injectable({ providedIn: 'root' })
export class JourneyParametersRuntimeService {
  private readonly paramsSubject = new BehaviorSubject<Record<string, unknown>>({});

  readonly params$: Observable<Record<string, unknown>> = this.paramsSubject.asObservable();
  readonly params = signal<Record<string, unknown>>({});

  setParamValues(values: Record<string, unknown> | null | undefined): void {
    const next = values ?? {};
    this.paramsSubject.next(next);
    this.params.set(next);
  }

  getParam(key: string): unknown {
    return this.paramsSubject.value[key];
  }

  clear(): void {
    this.setParamValues({});
  }
}
